import { render } from "./incomeWzz.vue?vue&type=template&id=088231ea&scoped=true"
import script from "./incomeWzz.vue?vue&type=script&lang=js"
export * from "./incomeWzz.vue?vue&type=script&lang=js"

import "./incomeWzz.vue?vue&type=style&index=0&id=088231ea&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088231ea"]])

export default __exports__